export default function fetchRoutes() {
  return {
    type: "FETCH_ROUTES"
  };
}
